import { createFileRoute } from '@tanstack/react-router'
import { requiredRoles } from '@/shared/utils/require-roles'
import { AuthPageContainer } from '@/components/shared/layouts'
import TabsComponent, { Tab } from '@/components/shared/tabs'
import { ReconciliationScreen } from '@/components/invoices/reconciliation/reconciliation-screen'
import { PastRunsList } from '@/components/invoices/reconciliation/past-runs-list'

type ReconciliationTabValue = 'new' | 'history'

const VALID_TABS: ReconciliationTabValue[] = ['new', 'history']

export type ReconciliationSearch = {
  tab: ReconciliationTabValue
}

export const Route = createFileRoute(
  '/_authenticated/org/$orgId/invoices/reconciliation'
)({
  validateSearch: (search: Record<string, unknown>): ReconciliationSearch => {
    const tab = search.tab as ReconciliationTabValue
    return { tab: VALID_TABS.includes(tab) ? tab : 'new' }
  },
  // SUPER_ADMIN only — requiredRoles([]) lets SUPER_ADMIN bypass and rejects
  // every other role (matches the invoice-stats-cards gating, #1281).
  beforeLoad: () => {
    requiredRoles([])
  },
  component: ReconciliationPage,
})

function ReconciliationPage() {
  const { tab } = Route.useSearch()
  const navigate = Route.useNavigate()

  const tabs: Tab<ReconciliationTabValue>[] = [
    {
      name: 'Nouveau rapprochement',
      value: 'new',
      content: <ReconciliationScreen />,
    },
    {
      name: 'Historique',
      value: 'history',
      content: <PastRunsList />,
    },
  ]

  return (
    <AuthPageContainer headerTitle='Rapprochement des paiements'>
      <TabsComponent
        tabs={tabs}
        defaultValue='new'
        value={tab}
        onTabChange={(value: ReconciliationTabValue) =>
          navigate({ search: { tab: value } })
        }
      />
    </AuthPageContainer>
  )
}
